import React, { useEffect, useState } from 'react';
export function OfferCountdown() {
  const [timeLeft, setTimeLeft] = useState(() => {
    const stored = sessionStorage.getItem('piano-offer-end');
    if (stored) {
      const diff = Math.max(0, Math.floor((parseInt(stored) - Date.now()) / 1000));
      return diff;
    }
    const endTime = Date.now() + 24 * 60 * 60 * 1000;
    sessionStorage.setItem('piano-offer-end', endTime.toString());
    return 24 * 60 * 60;
  });
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => {
      setTimeLeft(prev => prev <= 1 ? 0 : prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  const Box = ({
    value,
    label
  }: {
    value: string;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-342">
      <div className="bg-navy border border-gold/40 rounded-lg px-3 py-2 md:px-4 md:py-3 min-w-[56px] md:min-w-[68px]" data-id="element-343">
        <span className="text-2xl md:text-3xl font-black text-gold tabular-nums" data-id="element-344">
          {value}
        </span>
      </div>
      <span className="text-[10px] md:text-xs text-beige/50 uppercase tracking-wider mt-1" data-id="element-345">
        {label}
      </span>
    </div>;
  return <div className="flex items-center justify-center gap-2 md:gap-3" data-id="element-346">
      <Box value={pad(hours)} label="Horas" data-id="element-347" />
      <span className="text-2xl md:text-3xl font-black text-gold pb-5" data-id="element-348">:</span>
      <Box value={pad(minutes)} label="Min" data-id="element-349" />
      <span className="text-2xl md:text-3xl font-black text-gold pb-5" data-id="element-350">:</span>
      <Box value={pad(seconds)} label="Seg" data-id="element-351" />
    </div>;
}